import Latlng from './latlng';
import { genTimeKey, genkey } from '../common';
import util from '@/common/util';

export function getAggregationMarkers({ aggregation }) {
    if (!aggregation) {
        return [];
    }
    let aggregationMarkers = [];
    Latlng.iterateLocation(aggregation, (lat, lng, i, data) => {
        const bounds = [...(data.bounds || [])];
        for (let k = 0, klen = bounds.length; k < klen; k++) {
            const bound = bounds[k];
            bounds[k] = {
                lat: +Latlng.getLatitude(bound),
                lng: +Latlng.getLongitude(bound),
            };
        }
        let obj = {
            type: 'aggre',
            id: data.id || lat + '-' + lng,
            key: genTimeKey(lat, lng, i),
            lat,
            lng,
            count: data.count,
            label: data.label,
            bounds,
            originData: data,
        };
        aggregationMarkers.push(obj);
    });
    return aggregationMarkers;
}

export function filterVOWStatusData(list, userEmailVerified) {
    if (userEmailVerified) {
        return list;
    }
    let temp = [];
    list?.forEach?.((it) => {
        // soldProtected like "Sold,Active,Pending"
        const curSoldProtected = it.mlsOrg.soldProtected || '';
        if (!curSoldProtected.includes(it.listingStatus)) {
            temp.push(it);
        }
    });
    return temp;
}

export function getHouseMarkers({ house, userEmailVerified, page }) {
    if (!house) {
        return [];
    }
    let houseList = [];
    const filterHouseList = filterVOWStatusData(house, userEmailVerified);
    houseList = Latlng.generateDataByLatlng(filterHouseList);
    houseList.forEach((marker, index) => {
        let min = marker.items.reduce((pre, cur) => {
            if (pre == null) {
                return cur;
            } else {
                let prePrice = pre.soldDate ? pre.soldPrice : pre.price;
                let curPrice = cur.soldDate ? cur.soldPrice : cur.price;
                if (prePrice > curPrice) {
                    return cur;
                } else {
                    return pre;
                }
            }
        }, null);
        let houseForMls = page.mlsOrgs?.find?.((mls) => mls.id === marker.items[0]?.mlsOrg?.id) || { showSoldPrice: 1 };
        let showSoldPrice = page.house?.showSoldPrice && houseForMls.showSoldPrice;
        marker.price = min.soldDate && showSoldPrice ? min.soldPrice : min.price;
        marker.nodisclosureDes = min.nodisclosureDes;
        marker.key = genTimeKey(marker.lat, marker.lng, index);
        marker.vow = !!min.mlsOrg.soldProtected; //  This controls the display of map prices
    });
    return houseList;
}

export function getListingMarkers({ listing, userEmailVerified, page }) {
    if (!listing) {
        return [];
    }
    let ListingList = [];
    // 过滤掉vow状态的房子
    const filterListingList = filterVOWStatusData(listing, userEmailVerified);
    ListingList = Latlng.generateDataByLatlng(filterListingList);
    ListingList.forEach((marker, index) => {
        let min = marker.items.reduce((pre, cur) => {
            if (pre == null) {
                return cur;
            } else {
                let prePrice = pre.soldDate ? pre.soldPrice : pre.price;
                let curPrice = cur.soldDate ? cur.soldPrice : cur.price;
                if (prePrice > curPrice) {
                    return cur;
                } else {
                    return pre;
                }
            }
        }, null);
        let houseForMls = page.mlsOrgs?.find?.((mls) => mls.id === marker.items[0]?.mlsOrg?.id) || {
            showSoldPrice: 1,
        };
        let showSoldPrice = page.house?.showSoldPrice && houseForMls.showSoldPrice;
        marker.price = min.soldDate && showSoldPrice ? min.soldPrice : min.price;
        marker.nodisclosureDes = min.nodisclosureDes;
        marker.keepHighlight = true;
        marker.key = genkey(marker.lat, marker.lng, Date.now(), 'light', index);
        marker.vow = !!min.mlsOrg.soldProtected; //  This controls the display of map prices
    });
    return ListingList;
}

function checkSchoolUnique(list, data) {
    for (let i = 0, len = list.length; i < len; i++) {
        let tmp = list[i];
        if (tmp.name === data.name && tmp.address === data.address && tmp.gradeRange === data.gradeRange) {
            return false;
        }
    }
    return true;
}

export function getSchoolMarkers({ school, mapTheme }) {
    if (!school) {
        return [];
    }
    let schoolList = [];
    const idxMap = {};
    Latlng.iterateLocation(school, (lat, lng, i, data) => {
        const latlng = lat + ',' + lng;
        const idx = idxMap[latlng];
        if (!idx) {
            idxMap[latlng] = {
                idx: schoolList.length,
                score: data.gsRating,
            };
            let markerStyle = data.gsRating > 9 ? 'high' : data.gsRating >= 6 ? 'middle' : '';
            markerStyle += markerStyle ? ' score-' + data.gsRating : 'score-' + data.gsRating;
            schoolList.push({
                markerStyle: markerStyle,
                names: [data.name],
                originData: [data],
                icon: mapTheme === 'classic' ? 'icon-school3' : 'icon-school2',
                type: 'school',
                id: (data.id || lat + '-' + lng) + (data.level || ''),
                key: genTimeKey(lat, lng, i),
                lat,
                lng,
            });
        } else {
            const score = data.score;
            const originData = schoolList[idx.idx].originData;
            if (checkSchoolUnique(originData, data)) {
                schoolList[idx.idx].names.push(data.name);
                originData.push(data);
                if (score > idx.score) {
                    schoolList[idx.idx].markerStyle = score > 9 ? 'high' : score >= 6 ? 'middle' : '';
                    idx.score = score;
                }
            }
        }
    });
    return schoolList;
}

export const businessCategoryOrderMap = {
    // 重要优先级 (搬入/居住初期非常重要)
    'Home Services': {
        order: 1,
        icon: 'icon-a-HomeServices'
    },
    'Health & Medical': {
        order: 2,
        icon: 'icon-a-HealthMedical'
    },
    'Local Services': {
        order: 3,
        icon: 'icon-a-LocalServices'
    },
    'Shopping': {
        order: 4,
        icon: 'icon-Shopping'
    },
    'Restaurants': {
        order: 5,
        icon: 'icon-Restaurants'
    },
    'Real Estate': {
        order: 6,
        icon: 'icon-a-RealEstate'
    },

    // 中优先级 (生活质量，娱乐休闲)
    'Recreation': {
        order: 7,
        icon: 'icon-Recreation'
    },
    'Arts & Entertainment': {
        order: 8,
        icon: 'icon-a-ArtsEntertainment'
    },
    'Food': {
        order: 9,
        icon: 'icon-Food'
    },
    'Beauty': {
        order: 10,
        icon: 'icon-Beauty'
    },
    'Nightlife': {
        order: 11,
        icon: 'icon-Nightlife'
    },
    'Event Planning & Services': {
        order: 12,
        icon: 'icon-a-EventPlanningServices'
    },

    // 低优先级 (非日常需求或特定场景)
    'Automotive': {
        order: 13,
        icon: 'icon-Automotive'
    },
    'Religious Organizations': {
        order: 14,
        icon: 'icon-a-ReligiousOrganizations'
    },
    'Financial Services': {
        order: 15,
        icon: 'icon-a-FinancialServices'
    },
    'Professional Services': {
        order: 16,
        icon: 'icon-a-ProfessionalServices'
    },
    'Travel': {
        order: 17,
        icon: 'icon-Travel'
    },
}

const getBusinessIcon = ({ categoryLabel, mapTheme }) => {
    if (mapTheme === 'classic') {
        return 'icon-show';
    }
    return 'icon-business';
}

export function getBusinessMarkers({ business, mapTheme }) {
    if (!business) {
        return [];
    }
    let businessList = [];
    const idxMap = {};
    Latlng.iterateLocation(business, (lat, lng, i, data) => {
        const latlng = lat + ',' + lng;
        const idx = idxMap[latlng];
        if (isNaN(idx)) {
            idxMap[latlng] = businessList.length;
            businessList.push({
                names: [data.name],
                originData: [data],
                type: 'business',
                icon: data.icon || getBusinessIcon({ mapTheme }),
                id: data.id || lat + '-' + lng,
                key: genTimeKey(lat, lng, i),
                lat,
                lng,
            });
        } else {
            businessList[idx].names.push(data.name);
            businessList[idx].originData.push(data);
        }
    });
    return businessList;
}

export function getSubwayMarkers({ subway }) {
    if (!subway) {
        return [];
    }
    let subwayList = [];
    const idxMap = {};
    Latlng.iterateLocation(subway, (lat, lng, i, data) => {
        const latlng = lat + ',' + lng;
        const idx = idxMap[latlng];
        if (isNaN(idx)) {
            idxMap[latlng] = subwayList.length;
            subwayList.push({
                names: [data.name],
                originData: [data],
                type: 'subway',
                icon: data.icon || 'icon-M',
                id: data.id || lat + '-' + lng,
                key: genTimeKey(lat, lng, i),
                lat,
                lng,
            });
        } else {
            subwayList[idx].names.push(data.name);
            subwayList[idx].originData.push(data);
        }
    });
    return subwayList;
}

export function getLocationMarkers({ location, markerData }) {
    if (!location) {
        return [];
    }
    let locationList = [];
    if (!util.isArray(location)) {
        location = [location];
    }
    Latlng.iterateLocation(location, (lat, lng, i, locationData) => {
        locationList.push({
            names: [locationData.address],
            type: 'location',
            icon: locationData.icon || markerData.icon || '',
            lat,
            lng,
            id: locationData.id || lat + '-' + lng,
            key: lat + '-' + lng + '-' + i,
            showAddress: markerData.showAddress || false,
        });
    });
    return locationList;
}

export function getCityMarkers({ city }) {
    if (!city) {
        return [];
    }
    let cityList = [];
    for (let i = 0, len = city.length; i < len; i++) {
        const data = city[i];
        if (!data) {
            continue;
        }
        const lat = Latlng.getLatitude(data);
        const lng = Latlng.getLongitude(data);
        if (Latlng.isLatlngAvailable(lat, lng)) {
            cityList.push({
                id: data.id || lat + '-' + lng,
                key: genTimeKey(lat, lng, i),
                lat,
                lng,
                link: data.url,
                address: data.label,
                detail: data.detail,
                originData: data,
            });
        }
    }
    return cityList;
}

function hasMarker(list, { lat, lng }) {
    for (let i = 0, len = list.length; i < len; i++) {
        let marker = list[i];
        if (marker.lat === lat && marker.lng === lng) {
            return true;
        }
    }
    return false;
}

function filterHouseListByDensity(list, rectZoom) { 
    if (rectZoom.zoom > 15) {
        return list;
    }
    let minLng = rectZoom.rect.split(',')[1]
    let minLat = rectZoom.rect.split(',')[2]
    let maxLng = rectZoom.rect.split(',')[3]
    let maxLat = rectZoom.rect.split(',')[0]
    // Each grid cell stores the index list of houses that fall into that cell
    const gridIndexList = Array(5)
        .fill(null)
        .map(() => Array(5).fill(null).map(() => []));
    const latStep = (maxLat - minLat) / 5;
    const lngStep = (maxLng - minLng) / 5;
    list.forEach((house, index) => {
        let gridX = Math.floor((house.lng - minLng) / lngStep);
        let gridY = Math.floor((house.lat - minLat) / latStep);
        // Prevent out of bounds (may occur when equal to boundary value causing index == 5)
        gridX = Math.min(Math.max(gridX, 0), 4);
        gridY = Math.min(Math.max(gridY, 0), 4);
        gridIndexList[gridY][gridX].push(index);
    });

    // First set all houses' showPrice to false, then randomly select 2 houses for each grid (or all if less than 2) to show price
    const result = list.map(prop => ({ ...prop, showPrice: false }));
    for (let y = 0; y < 5; y++) {
        for (let x = 0; x < 5; x++) {
            const indexes = gridIndexList[y][x];
            if (!indexes.length) {
                continue;
            }
            if (indexes.length <= 2) {
                // Less than 2 houses, show all
                indexes.forEach(idx => (result[idx].showPrice = true));
            } else {
                // Randomly select 2 houses, use Set to avoid duplicates
                const picked = new Set();
                while (picked.size < 2) {
                    picked.add(indexes[Math.floor(Math.random() * indexes.length)]);
                }
                picked.forEach(idx => (result[idx].showPrice = true));
            }
        }
    }
    return result;
}

export function calcAddress({ addressStreet, addressCity, addressState, addressZip }) {
    let ret = [addressStreet, addressCity, `${addressState} ${addressZip}`];
    return ret.filter(item => item.trim()).join(', ');
}

export function getMarkers() {
    const markerData = this.markerData;

    const aggregationMarkers = getAggregationMarkers({ aggregation: markerData.aggregation });
    if (!util.isObjectSameSafe(this.aggregationMarkers, aggregationMarkers, false, ['key'])) {
        this.aggregationMarkers = aggregationMarkers;
    }

    let houseList = getHouseMarkers({
        house: markerData.house,
        userEmailVerified: this.userEmailVerified,
        page: this.page,
    });

    if (houseList.length > 0 && markerData?.rectZoom?.rect) {
        houseList = filterHouseListByDensity(houseList, markerData.rectZoom);
    }
    
    if (!util.isObjectSameSafe(this.houseMarkers, houseList, false, ['key'])) {
        this.houseMarkers = houseList;
    }

    let ListingList = getListingMarkers({
        listing: markerData.listing,
        userEmailVerified: this.userEmailVerified,
        page: this.page,
    });
    if (!util.isObjectSameSafe(this.listingMarkers, ListingList, false, ['key'])) {
        for (let i = this.listingMarkers.length - 1; i >= 0; i--) {
            let marker = this.listingMarkers[i];
            marker.destroyed = true;
            if (!hasMarker(ListingList, marker)) {
                marker.hidden = true;
            }
        }
        this.listingMarkers.push(...ListingList);
    }

    const schoolList = getSchoolMarkers({ school: markerData.school, mapTheme: this.mapTheme });
    const businessList = getBusinessMarkers({ business: markerData.business, mapTheme: this.mapTheme });
    const subwayList = getSubwayMarkers({ subway: markerData.subway });
    const locationList = getLocationMarkers({ location: markerData.location, markerData });
    const iconMarkers = [...schoolList, ...businessList, ...subwayList, ...locationList];
    if (!util.isObjectSameSafe(this.iconMarkers, iconMarkers, false, ['key'])) {
        this.iconMarkers = iconMarkers;
    }

    const cityMarkers = getCityMarkers({ city: markerData.city });
    if (!util.isObjectSameSafe(this.cityMarkers, cityMarkers, false, ['key'])) {
        this.cityMarkers = cityMarkers;
    }
}
